import React from 'react';
import CampaignDashboard from './CampaignDashboard';
import { ICampaign, ICampaignMetrics } from '../interface/ICampaign';
import { IGuestConnectSettings } from '../interface/IGuestConnectSettings';

interface GuestConnectProps {
	// Campaign management props
	campaigns?: ICampaign[];
	metrics?: ICampaignMetrics;
	_availableRewards?: Array<{ id: string; name: string }>;
	organizationId: string;
	baseUrl?: string;
	settings?: IGuestConnectSettings;
}

/**
 * GuestConnect - Campaign Management System
 * 
 * This is the main component for managing guest feedback campaigns.
 * It allows users to:
 * - View campaign metrics and sentiment analysis
 * - Create, edit, and delete campaigns
 * - Manage questions (yes/no or 1-5 rating scale)
 * - Attach rewards and select winners
 * - Generate QR codes and unique URLs for campaigns
 * - View campaign results and analytics
 */
export default function GuestConnect({
	campaigns = [],
	metrics,
	_availableRewards = [],
	organizationId,
	settings
}: GuestConnectProps): JSX.Element {
	return (
		<CampaignDashboard
			campaigns={campaigns}
			metrics={metrics}
			organizationId={organizationId}
			settings={settings}
		/>
	);
}
